<template>
  <nav>
    <v-app-bar
        class="elevation-1 slide-in-down"
        color="primary"
        dark
        app>
      <v-app-bar-nav-icon @click="drawer = !drawer" color="white">
        <v-icon>mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title class="font-weight-bold ml-2 white--text">
        Elefante Task Manager
      </v-toolbar-title>

      <v-chip
          class="ml-4 text-uppercase font-weight-bold"
          color="success"
          small
          v-if="$store.state.user.role === 'ADMIN'">
        {{ $store.state.user.role }}
      </v-chip>

      <v-chip
          class="ml-4 text-uppercase font-weight-bold"
          color="warning"
          small
          v-else-if="$store.state.user.role === 'HEAD'">
        {{ $store.state.user.role }}
      </v-chip>

      <v-chip
          class="ml-4 text-uppercase font-weight-bold"
          color="info"
          small
          v-else>
        {{ $store.state.user.role }}
      </v-chip>

      <Alert :alert="alert"/>
      <v-spacer></v-spacer>

      <v-menu
          min-width="280px"
          rounded
          transition="slide-y-transition"
          offset-y>

        <template v-slot:activator="{ on, attrs }">
          <v-btn
              class="mr-2 transition-normal"
              icon
              v-bind="attrs"
              v-on="on">

            <v-avatar
                color="white"
                size="36">
              <span class="primary--text font-weight-bold">{{ user.initials }}</span>
            </v-avatar>
          </v-btn>
        </template>

        <v-card class="rounded-lg">
          <v-card-text class="pa-4">
            <div class="d-flex flex-column align-center">
              <v-avatar
                  color="primary"
                  size="80"
                  class="mb-4 elevation-2">
                <span class="white--text text-h4 font-weight-bold">{{ user.initials }}</span>
              </v-avatar>

              <h3 class="text-h5 font-weight-bold mb-1">{{ user.fullName }}</h3>
              <p class="text-body-2 text-secondary mb-4">
                {{ user.email }}
              </p>

              <div class="d-flex flex-column w-100">
                <div class="d-flex justify-space-between mb-2">
                  <v-btn
                      text
                      color="primary"
                  >
                    <v-icon left>mdi-account-edit</v-icon>
                    Profilo
                  </v-btn>

                  <v-btn
                      text
                      color="error"
                      @click="logout"
                  >
                    <v-icon left>mdi-logout</v-icon>
                    Logout
                  </v-btn>
                </div>

                <!-- Pulsante temporaneo refresh permessi -->
                <v-btn
                    text
                    color="orange"
                    small
                    @click="refreshUserPermissions"
                    class="mt-1"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Aggiorna Permessi
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
        app
        v-model="drawer"
        color="white"
        flat
        style="max-width: 280px;"
>
      <!-- Logo -->
      <v-list-item class="pa-4 mb-2">
        <v-list-item-content>
          <div class="d-flex align-center mb-2">
            <v-img src="@/assets/logo_small.png" max-width="120px" contain class="mr-2"></v-img>
          </div>
          <v-list-item-subtitle class="primary--text text-subtitle-1 font-weight-medium">
            Elefante Task Manager
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- Avatar utente -->
      <v-list-item class="px-4 py-3">
        <v-list-item-avatar>
          <v-avatar color="primary" size="44">
            <span class="white--text font-weight-bold">{{ user.initials }}</span>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content class="ml-2">
          <v-list-item-title class="font-weight-medium text-body-1">{{ user.fullName }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption grey--text">{{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mx-3"></v-divider>

      <v-list nav class="py-0">
        <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="item.link"
            class="my-1">
          <v-list-item-icon>
            <v-icon color="primary">{{ item.action }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
            no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon color="primary">mdi-database-clock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Backup</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
              v-for="(link, i) in links"
              :key="i"
              :to="{ name: 'backup', params: { anno_riferimento: link.params.search }}"
              class="pl-4">
            <v-list-item-icon class="mr-2" style="min-width: 24px;">
              <v-icon color="primary" size="18">{{ link.action }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-body-2">{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>


    </v-navigation-drawer>
  </nav>
</template>

<script>
import Alert from "./widgets/Alert";

export default {
  name: "Navbar",
  components: {Alert},
  data() {
    return {
      drawer: true,
      // alert: false,
      user: {
        initials: `${this.$store.state.user.first_name[0]}${this.$store.state.user.last_name[0]}`,
        fullName: this.$store.state.user.full_name,
        email: this.$store.state.user.email,
      },
      links: []
      // links: [
      //   {title:'2022', action:'mdi-update', link:'/progetti', params:{ search:2022 }},
      //   {title:'2021', action:'mdi-update', link:'/progetti', params:{ search:2021 }},
      //   {title:'Template', action:'mdi-blur', link:'/progetti', params:{ search:2000 }},
      // ],
    }
  },
  created() {
    // Aggiungi il link per l'anno 2000
    this.links.push({
      title: 'Template',
      action: 'mdi-blur',
      link: '/progetti',
      params: {search: 2000},
    });
    // this.links.push({
    //   title: '2025',
    //   action: 'mdi-update',
    //   link: '/progetti',
    //   params: {search: 2025},
    // });
    // Genera dinamicamente i link per gli anni dal 2021 fino all'anno corrente
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 2021; year--) {
      this.links.push({
        title: year.toString(),
        action: 'mdi-update',
        link: '/progetti',
        params: {search: year},
      });
    }
  },
  computed: {
    items() {
      const items = []
      if (this.$store.state.user.role !== 'MANAGEMENT_CONTROL') {
        items.push({action: 'mdi-format-list-bulleted-square', title: 'Progetti', link: '/projects',},);
      }
      if (['ADMIN', 'HEAD'].includes(this.$store.state.user.role)) {
        items.push({action: 'mdi-account-arrow-left', title: 'Insegne', link: '/customers'})
        items.push({action: 'mdi-account-arrow-right', title: 'Fornitori', link: '/providers'})
        // items.push({action: this.$icons.backup, title: 'Backup', link:'/'})
      }
      // items.push({action: this.$icons.task, title: 'Tasks', link: '/tasks'})
      items.push({action: 'mdi-lightning-bolt', title: 'Tasks', link: '/tasks2'})
      items.push({action: 'mdi-cog', title: 'Impostazioni', link: '/settings'})

      // Link admin solo per gli amministratori
      if (this.$store.state.user.role === 'ADMIN') {
        items.push({action: 'mdi-shield-account', title: 'Gestione Permessi', link: '/admin/permissions'})
      }

      return items;
    }
  },
  methods: {
    // Metodo temporaneo per ricaricare permessi utente
    async refreshUserPermissions() {
      try {
        console.log('🔄 Ricaricamento permessi utente...');
        await this.$store.dispatch('setCurrentUser');
        this.$dtoast.pop({
          preset: "success",
          content: "Permessi aggiornati!",
        });
        console.log('✅ Permessi aggiornati:', this.$store.getters.userPermissions);
      } catch (error) {
        console.error('❌ Errore aggiornamento permessi:', error);
        this.$dtoast.pop({
          preset: "error",
          content: "Errore aggiornamento permessi",
        });
      }
    },

    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({name: 'login'});
        this.$dtoast.pop({
          preset: "success",
          content: "Logout dal Sistema",
        })
      }).catch(error => {
        this.$dtoast.pop({
          preset: "error",
          content: `Logout dal Sistema non riuscito: ${error}`,
        })
      })
    },
    onClick(link) {
      this.$router.push(link)
    },
    alert(e) {
      console.log(e)
    },
    linkToBackup(year) {
      let params = {
        anno_riferimento: year
      }
      this.$projectService.list(params)
          .then(resp => {
            console.log(resp)
          })
      console.log(year)
    }
  }
}
</script>

<style scoped>
/* Stili per la navbar */
.v-app-bar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

/* Stili per gli elementi del menu */
.v-list-item {
  transition: all 0.2s ease;
}

.v-list-item:hover {
  background-color: rgba(92, 142, 214, 0.05) !important;
}

.v-list-item--active {
  background-color: rgba(92, 142, 214, 0.1) !important;
  border-left: 2px solid var(--if65-blue);
}

.v-list-item--active .v-list-item__title {
  color: var(--if65-blue) !important;
}

/* Stili per i chip */
.v-chip {
  transition: all 0.2s ease;
}

/* Stili per gli avatar */
.v-avatar {
  transition: all 0.2s ease;
}

/* Animazioni */
.slide-in-down {
  animation: slideInDown 0.3s ease;
}

@keyframes slideInDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
